import * as React from "react"
import {Grid} from "@mui/material"
import {CardSeeker} from "@ui-seeker/core"

import {USER_ROLES} from "@constants";
import {useUserApp} from "@hooks";
import StockSummaryCircularPercentage from "./CircularPercentage"
import StockAssortmentSummaryWidgetFooter from "./Footer";
import {useStockWidgetFilters} from "../@hooks"


export default function StockAssortmentSummaryWidget({ row, label, labelFormat, percentage, numDistinctSkus, skuScope, assortment, position, showSkuInfo, splitKpi }) {
    const { userRole } = useUserApp()
    const { isClicked, handleClick, handleClickEvolution } = useStockWidgetFilters(row, splitKpi)

    return <CardSeeker
        title={labelFormat? labelFormat(label, row) : label}
        sx={{
            cursor: "pointer",
            ":hover": { border: "2px solid", borderColor: 'grey.500' },
            ...isClicked && { border: "3px solid", borderColor: 'primary.main' }
        }}
        onClick={handleClick}
        headerProps={{ sx: { headerStyles: { ".MuiCardHeader-title": { display: 'flex', justifyContent: 'center' } } } }}
        footer={<StockAssortmentSummaryWidgetFooter skuScope={skuScope} numDistinctSkus={numDistinctSkus} showName={position === 0} showSkuInfo={showSkuInfo} onClick={handleClickEvolution} />}
    >
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <StockSummaryCircularPercentage
                    title={'Stock'}
                    percentage={percentage}
                />
            </Grid>

            <Grid item xs={6}>
                <StockSummaryCircularPercentage
                    title={userRole === USER_ROLES.RETAILER ? 'Affinity' : 'Assortment'}
                    percentage={assortment}
                />
            </Grid>
        </Grid>
    </CardSeeker>
}